import { LIBRARY_TABS_URL } from '@/consts/urls';
import { fetchLibraryData } from './utils';

import type { LibraryTab } from '@/types';

type ResponseType = {
  data: LibraryTab[];
};

const getLibraryTabs = async () => {
  return fetchLibraryData({
    url: LIBRARY_TABS_URL,
    transform: (response) => {
      const data = response as ResponseType;
      return data?.data || null;
    },
  });
};

export { getLibraryTabs };
